/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * * `Disabled` - DISABLED
 * * `Pending` - PENDING
 * * `Suspended` - SUSPENDED
 * * `Enabled` - ENABLED
 */
export enum GithubIntegrationTenantExtensionStatus {
  DISABLED = 'Disabled',
  PENDING = 'Pending',
  SUSPENDED = 'Suspended',
  ENABLED = 'Enabled',
}
